import { goRequest } from '../utils/httpClientTs';
import { GenericResponse } from '../types/generic';

export interface DelegateItem {
  id: string;
  user_id: string;
  user_name: string;
  delegate_type: 'delegate' | 'alternate';
  order: number;
}

export interface DelegatesResponse {
  delegates: DelegateItem[];
  alternates: DelegateItem[];
}

export interface DelegateReportingInfo {
  id: string;
  number_of_delegates: number;
  reported_on?: string;
  reported_by_id?: string;
  updated_on?: string;
  updated_by_id?: string;
  can_report: boolean;
}

export interface DelegateReportingResponse {
  reporting?: DelegateReportingInfo;
}

export interface DelegateCreateRequest {
  user_id: string;
  delegate_type: 'delegate' | 'alternate';
  order: number;
}

export interface DelegateUpdateRequest {
  order: number;
}

export interface DelegateReportingCreateRequest {
  year: number;
  number_of_delegates: number;
}

// Get delegates/alternates
export const getDelegates = (data: {
  id: string;
  year?: number;
  delegate_type?: 'delegate' | 'alternate';
}): Promise<DelegatesResponse> => {
  let url = `/membership/local_chapters/${data.id}/delegates`;
  const params = new URLSearchParams();
  if (data.year) {
    params.append('year', data.year.toString());
  }
  if (data.delegate_type) {
    params.append('delegate_type', data.delegate_type);
  }
  if (params.toString()) {
    url += `?${params.toString()}`;
  }
  return goRequest<DelegatesResponse>({
    url: url,
    method: 'GET',
  });
};

// Create delegate/alternate
export const createDelegate = (
  chapterId: string,
  data: DelegateCreateRequest
): Promise<DelegateItem> => {
  return goRequest<DelegateItem>({
    url: `/membership/local_chapters/${chapterId}/delegates`,
    method: 'POST',
    data: data,
  });
};

// Update delegate/alternate
export const updateDelegate = (
  chapterId: string,
  delegateId: string,
  data: DelegateUpdateRequest
): Promise<GenericResponse> => {
  return goRequest<GenericResponse>({
    url: `/membership/local_chapters/${chapterId}/delegates/${delegateId}`,
    method: 'PATCH',
    data: data,
  });
};

// Delete delegate/alternate
export const deleteDelegate = (
  chapterId: string,
  delegateId: string
): Promise<GenericResponse> => {
  return goRequest<GenericResponse>({
    url: `/membership/local_chapters/${chapterId}/delegates/${delegateId}`,
    method: 'DELETE',
  });
};

// Get delegate reporting
export const getDelegateReporting = (data: {
  id: string;
  year?: number;
}): Promise<DelegateReportingResponse> => {
  let url = `/membership/local_chapters/${data.id}/delegate-reporting`;
  if (data.year) {
    url += `?year=${data.year}`;
  }
  return goRequest<DelegateReportingResponse>({
    url: url,
    method: 'GET',
  });
};

// Create/update delegate reporting
export const createOrUpdateDelegateReporting = (
  chapterId: string,
  data: DelegateReportingCreateRequest
): Promise<{ reporting: DelegateReportingInfo }> => {
  return goRequest<{ reporting: DelegateReportingInfo }>({
    url: `/membership/local_chapters/${chapterId}/delegate-reporting`,
    method: 'POST',
    data: data,
  });
};
